import Heading from "../../../Components/Heading/Heading";
import TableAccountStatement from "./TableAccountStatement";

function AccountStatement() {
  return (
    <>
      <Heading heading="كشف حساب العميل" />
      <TableAccountStatement />
    </>
  );
}

export default AccountStatement;
